
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-getowner-polyfill/-embroider-implicit-modules.js";
